<template>
  <div v-if="isLoading" class="d-flex justify-content-center align-items-center" style="height: 100vh;">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</template>

<script>
import Config from '@/config'

export default {
  name: 'Auth',
  data() {
    return {
      isLoading: true
    }
  },
  async mounted() {
    const provider = this.$route.query.provider

    if (provider === 'google') {
      try {
        // Call backend API to exchange Google OAuth data for user token
        const res = await this.$http.get(Config.api.googleCallback, { params: this.$route.query })

        if (res.body && res.body.token) {
          // Store auth data same as email/password login
          this.$store.dispatch('setCurrentUser', res.body)
          this.$cookie.set('ahaTokenAdmin', res.body.token)
          this.$http.headers.common['Authorization'] = 'Bearer ' + res.body.token
          this.$cookie.set('ahaUserAdmin', res.body.user)

          // Redirect to home page
          this.$router.push('/apps/users')
        } else {
          // No token in response, redirect with error
          const errorMessage = (res.body && res.body.message) || 'Something went wrong'
          this.$router.replace({
            name: 'Login',
            query: { error: errorMessage }
          })
        }
      } catch (error) {
        console.error('Google login error:', error)
        // Extract error message from response
        let errorMessage = 'Something went wrong'
        if (error.body && error.body.message) {
          errorMessage = error.body.message
        } else if (error.status && error.status >= 400) {
          errorMessage = (error.body && error.body.message) || error.bodyText || 'Authentication failed'
        }

        this.$router.replace({
          name: 'Login',
          query: { error: errorMessage }
        })
      }
    } else {
      this.$router.replace({ name: 'Login' })
    }
  }
}
</script>
